import React from 'react';

const NebulaDecisionTemplatesFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaDecisionTemplatesModalRegistry = {
    personalize_nebulaDecisionTemplatesId: NebulaDecisionTemplatesFormModal
};
export default nebulaDecisionTemplatesModalRegistry;
